<script>
import LoadingTemplate from "@/components/widgets/loading-template.vue";
import RawData from '@/components/widgets/raw-data.vue'
export default {
    name: "AvailableBursList",
    components: {
        LoadingTemplate,
        RawData
    },
    props: {
        type: {
            type: String,
            default: 'pending'
        },
        loading: {
            type: Boolean,
            default: false,
        },
        payments: {
            type: Array,
            default: () => [],
        },
        purchases: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        list(){
            if(this.tabModel == 1){
                return this.purchases;
            } else {
                return this.payments;
            }
        },
        filtered(){
            let data = this.list;
            var total = this.currentPage * this.perPage;
            if(this.filter){
                data = data.filter(item => {
                    return item.filterKey.toLowerCase().includes(this.filter.toLowerCase())
                });
            }
            var currentData = data.slice(total - this.perPage, total);
            if (this.currentPage > 1 && currentData.length == 0) {
                total = (this.currentPage - 1) * this.perPage;
                currentData = data.slice(total - this.perPage, total);
            }
            return currentData;
        },
        rows(){
            let data = this.list;
            if (this.filter && this.filter.trim() != "") {
                data = data.filter((item) => {
                    return item.filterKey
                        .toUpperCase()
                        .includes(this.filter.toUpperCase());
                });
            }
            return data.length;
        },
    },
    data() {
        return {
            tabModel: 1,
            filter: "",
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 15, 20, 50, 100],
        }
    },
    methods: {
        
    },
}
</script>
<template>
  <section class="border-s">
    <div class="card">
        <div class="card-body bg-primary bg-soft">
            <div
                class="
                    d-flex
                    justify-content-between
                    align-items-center
                    mb-3
                "
            >
                <div>
                    <h4 class="card-title mb-0">
                        Available Request for Budget Utilization Request
                    </h4>
                    <p class="card-title-desc mb-0">
                        List of Available Request for Budget Utilization
                    </p>
                </div>
                <div class="d-flex">
                    <div class="d-flex gap-1 me-2">
                        <div class="border pur-list" :class="{'active': tabModel == 1}" @click="tabModel = 1">Purchases</div>
                        <div class="border pur-list" :class="{'active': tabModel == 2}" @click="tabModel = 2">Other Transactions</div>
                    </div>
                    <input
                        autocomplete="off"
                        type="text"
                        v-model="filter"
                        placeholder="Search Request..."
                        class="form-control"
                    />
                    <b-form-select
                        class="form-select ms-1 w-25"
                        v-model="perPage"
                        :options="pageOptions"
                    ></b-form-select>
                </div>
            </div>
            <div v-if="loading" class="text-center my-5 py-5">
                <LoadingTemplate class="my-5"/>
            </div>
            <div v-if="!loading && list.length == 0" class="text-center py-5 my-5">
                <h5>No data available</h5>
            </div>
            <div v-if="!loading && list.length && !filtered.length" class="text-center">
                <h5>Search not found</h5>
            </div>
            <template v-if="!loading && list.length">
                 <div
                    role="tablist"
                    v-for="(y, index) in filtered"
                    :key="y.id"
                >
                    <b-card
                        no-body
                        class="mb-1 shadow-none"
                        :style="{'z-index': `${filtered.length - index}`}"
                    >
                        <RawData :data="y" v-if="$store.state.decrypt.isAdmin()" placement="left"/>
                        <b-card-header
                            header-tag="header"
                            role="tab"
                            header-class="cursor-pointer"
                            @click="y.viewDetails = !y.viewDetails"
                        >
                            <div
                                class="
                                    d-flex
                                    justify-content-between
                                    align-items-center
                                "
                            >  
                                <div class="line-height-1">
                                    <h6 class="m-0">
                                        <a class="text-dark" href="javascript: void(0);">
                                            &nbsp;
                                            <span>[{{y.rfpNumber}}]</span>
                                            :&nbsp;
                                            {{ y.particulars || '-' }} <span class="text-yellow">({{ formatCurrency(y.totalAmount) }})</span>
                                        </a>
                                    </h6>
                                    <small class="text-white">{{y.deliveryUnit}}</small>
                                </div>
                                <div class="d-flex align-items-center">
                                    <div>
                                        <span class="d-flex align-items-center text-truncate">
                                            <small v-if="!y.viewDetails">Click here to expand</small>
                                            <i 
                                                class="bx bx-chevron-right rotate font-size-18 ms-3"
                                                :class="{'rotate-90': y.viewDetails }"
                                            ></i
                                        ></span>
                                    </div>
                                </div>
                            </div>
                        </b-card-header>
                        <b-collapse
                            :visible="y.viewDetails"
                            :accordion="`accordion-${y.id}`"
                            role="tabpanel"
                        >
                            <div class="card-body border">
                                <div class="row">
                                    <div class="col-md-7 border-end">
                                        <div class="position-relative">
                                            <div class="position-absolute" style="top: 10px; right: 10px;">
                                                <a href="javascript:;" class="font-size-18" @click="$emit('update', y)"><i class="bx bx-edit"></i></a>
                                            </div>
                                            <table class="w-100">
                                                <tr>
                                                    <td class="px-2">Particulars:</td>
                                                    <td class="px-2"><strong>{{y.particulars}}</strong></td>
                                                </tr>
                                                <tr>
                                                    <td class="px-2">Serial Number:</td>
                                                    <td class="px-2"><strong>{{y.rfpNumber}}</strong></td>
                                                </tr>
                                                <tr>
                                                    <td class="px-2">Total Amount:</td>
                                                    <td class="px-2"><strong>{{formatCurrency(y.totalAmount)}}</strong></td>
                                                </tr>
                                                <tr>
                                                    <td class="px-2 pt-2">Request For Payment Number:</td>
                                                    <td class="px-2 pt-2"><strong>{{y.rfpNumber}}</strong></td>
                                                </tr>
                                                <tr>
                                                    <td class="px-2">Payee:</td>
                                                    <td class="px-2"><strong>{{y.payee || '-'}}</strong></td>
                                                </tr>
                                                <tr>
                                                    <td class="px-2">Delivery Unit:</td>
                                                    <td class="px-2"><strong>{{y.deliveryUnit || '-'}}</strong></td>
                                                </tr>
                                                <tr>
                                                    <td class="px-2">Created By:</td>
                                                    <td class="px-2"><strong>{{y.createdByUser || '-'}}</strong></td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                    <div class="col-md-5">
                                        <h5>Allotment Charging</h5>
                                        <div class="bg-info bg-soft py-2 px-3 rounded" v-if="y.rfpAccounts.length > 0">
                                            <div v-for="(account, index) in y.rfpAccounts" :key="index">
                                                <p class="d-block mb-0">{{account.uacs}}</p>
                                                <h4 class="mb-0">{{ account.account }}</h4>
                                                <div class="text-right mt-3">
                                                    <h3 class="mb-0 text-warning">{{ formatCurrency(account.amount) }}</h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="d-flex justify-content-end gap-1 border-top pt-3 mt-2">
                                    <button type="buttton" class="btn btn-outline-warning btn-rounded" @click="$emit('attachment', {att: ['po', 'rfp'], id: y.id})"><i class="bx bx-paperclip rotate rotate-45"></i> Attachments</button>
                                    <button type="buttton" class="btn btn-outline-danger btn-rounded" @click="$emit('reject', y)"><i class="bx bx-x"></i> Reject</button>
                                    <button type="buttton" class="btn btn-outline-success btn-rounded" @click="$emit('create', y)"><i class="bx bx-check"></i> Obligate</button>
                                </div>
                            </div>
                        </b-collapse>
                    </b-card>
                </div>
                <div class="row mt-3" v-if="rows > 0">
                    <div class="col">
                        <div
                            class="
                                dataTables_paginate
                                paging_simple_numbers
                                float-end
                            "
                        >
                            <ul
                                class="
                                    pagination pagination-rounded
                                    mb-0
                                "
                            >
                                <!-- pagination -->
                                <b-pagination
                                    v-model="currentPage"
                                    :total-rows="rows"
                                    :per-page="perPage"
                                ></b-pagination>
                            </ul>
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </div>
  </section>
</template>
<style lang="scss">
.dot-success{
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: var(--bs-success);
    margin-right: 5px;
}
.border-top{
    border-top: 1px solid var(--bs-border-color);
}
</style>